import { useState, useEffect } from "react";
import AmountPicker from "./amount_picker";
import DonateButton from "./donate_button";

const DonateForm = ({ setActivePaymentMethod, selectedPlan }) => {
  const [amount, setAmount] = useState("");

  useEffect(() => {
    if (selectedPlan && selectedPlan.amount) {
      setAmount(selectedPlan.amount);
    }
  }, [selectedPlan]);

  return (
    <form className="DonateForm">
      {!selectedPlan && <AmountPicker setAmount={setAmount} />}
      <DonateButton
        currency="USD"
        amount={amount}
        setActivePaymentMethod={setActivePaymentMethod}
        selectedPlan={selectedPlan}
      />
    </form>
  );
};

export default DonateForm;
